<template>
    <Layout>
        <div class="row">
            <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if="show">
                <span :key="index" v-for="(err, index) in validation_errors">
                  {{ err[0] }} <br/>
                </span>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <b-card>
                    <PageHeader :title="title" :items="items" style="margin-top: -30px"/>
                    <form action="">
                        <div class="form-row mt-1">
                            <div class="col-md-6 col-sm-6 col-lg-6">
                                <label for="trade_id">Training Trade <span class="c-required">*</span></label>
                                <select v-model="search_data.trade_id"
                                        id="trade_id"
                                        name="trade_id"
                                        class="form-control form-control-sm"
                                >
                                    <option :value="''" selected>Select Training Trade</option>
                                    <option :key="index"
                                            v-bind:value="trade.id"
                                            v-for="(trade, index) in trades">
                                        {{ trade.id }} : {{ trade.desc }}
                                    </option>
                                </select>
                            </div>
                            <div class="col-md-6 col-sm-6 col-lg-6 custom-search">
                                <button class="btn btn-success btn-sm custom-search-button" @click.prevent="search">
                                    Search
                                </button>
                            </div>
                        </div>

                    </form>
                </b-card>
                <b-card>
                    <div v-if="trade_courses.length > 0" class="row mb-2">
                        <div class="col-sm-4">
                            <span class="badge badge-success mr-2">Total Search Data Found: {{ trade_courses.length }}</span>
                        </div>
                    </div>
                    <div class="table-responsive" style="overflow-x: auto">
                        <table class="table table-centered table-striped">
                            <thead>
                            <tr>
                                <th>Sl</th>
                                <th>Title</th>
                                <th>Days</th>
                                <th>Description</th>
                                <th>File</th>
                                <th>Remarks</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(trade_course, index) in trade_courses" :key="index">
                                <td>{{ index + 1 }}</td>
                                <td>{{ trade_course.title }}</td>
                                <td>{{ trade_course.days }}</td>
                                <td>{{ trade_course.description }}</td>
                                <td>
                                    <a :href="trade_course.file" target="_blank">Course File</a>
                                </td>
                                <td>{{ trade_course.remarks }}</td>
                            </tr>
                            </tbody>
                        </table>
                        <h5 class="text-center text-secondary" v-if="trade_courses.length === 0">
                            No Data Found
                        </h5>
                    </div>
                </b-card>
            </div>
        </div>
    </Layout>
</template>

<script>
    import appConfig from "@src/app.config";
    import Layout from "@layouts/main";
    import PageHeader from "@components/page-header";
    import http from "@state/http";

    export default {
        page: {
            title: "Trade Course List",
            meta: [{name: "description", content: appConfig.description}]
        },
        components: {Layout, PageHeader},
        data() {
            return {
                title: "Search Trade Course",
                items: [
                    {
                        text: "Dashboard",
                        href: "/"
                    },
                    {
                        text: "Trade Course",
                        active: true
                    }
                ],
                trade_courses: {},
                search_data: {
                    trade_id: ''
                },
                validation_errors: {},
                trades: [],
                show: false,
            };
        },

        mounted() {
            this.getTrade();
        },
        methods: {
            search() {
                http.post("api/trainee/trade/course/search", this.search_data).then(response => {
                    if (!response.error) {
                        this.trade_courses = response.data.trade_courses;
                    }
                });
            },
            getTrade() {
                http
                    .get("api/trainee/trade/course/getTrade")
                    .then(response => {
                        this.trades = response.data.trades;
                    })
                    .catch();
            },
            onDelete(id, index) {
                if (confirm("Do you really want to delete?")) {
                    http.delete("api/trainee/trade/course/delete/" + id)
                        .then(response => {
                            if (response.data.permissionError) {
                                this.$bvToast.toast(response.data.permissionError, {
                                    title: "Error",
                                    autoHideDelay: 5000,
                                    variant: "danger"
                                });
                            } else {
                                this.batches.splice(index, 1);
                                this.$bvToast.toast(response.data.message, {
                                    title: "Success",
                                    autoHideDelay: 5000,
                                    variant: "success"
                                });
                            }
                    });
                }
            },
        },
        computed: {
            userPermission () {
                return this.$store.state.user
            }
        },
        created () {
            this.$store.dispatch('getUserPermission')
        },
    };
</script>
